import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

// Import reducers
import authReducer from './slices/authSlice';
import presentationReducer from './slices/presentationSlice';
import votingReducer from './slices/votingSlice';
import userReducer from './slices/userSlice';
import themeReducer from './slices/themeSlice';
import realTimeReducer from './slices/realTimeSlice';

// Import API services
import { api } from './api';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    presentations: presentationReducer,
    voting: votingReducer,
    users: userReducer,
    theme: themeReducer,
    realTime: realTimeReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

// Enable refetchOnFocus and refetchOnReconnect
setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
